import React from 'react'
import ModalConsulta from './ModalConsulta';
import { Tabela } from '../Basicos';

function ModalConsultaProfessorAnalitico(props) {
    const { estrutura } = props;
    const { professores } = estrutura?.modal;

    const columns = React.useMemo(
        () => [{
            Header: "Professores",
            style: {
                display: 'none',
            },
            columns: [
                {
                    Header: 'Titulação',
                    accessor: 'titulacao',
                },
                {
                    Header: 'Nome',
                    accessor: 'professor',
                },
                {
                    Header: 'Especialidade',
                    accessor: 'especialidade',
                },
                {
                    Header: 'Tipo Formação',
                    accessor: 'tipo_formacao',
                },
                {
                    Header: 'Temas',
                    accessor: 'temas',
                },
                {
                    Header: 'Semestres',
                    accessor: 'semestres',
                }
            ],
        }],
        []
    )

    return (
        <ModalConsulta
            data={props.data}
            modalClass="modal-map"
            modalBodyClass="modalConsulta"
            size="lg"
            {...props}
        >
            <Tabela
                columns={columns}
                data={professores}
                tabelaClassName="tabelaConsulta"
            />
        </ModalConsulta>
    );
}

export default ModalConsultaProfessorAnalitico;
